import React from 'react';
import Sidebar from '../components/Layout/Sidebar';
import Gateways from '../components/Profile/Gateways';
const GatewaysPage = () => {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1">
        <Gateways />
      </div>
    </div>
  );
};
export default GatewaysPage;
